<template>
  <div>
    <el-dialog v-model="obj.dialogFormVisible" :close-on-click-modal="false" title="问题反馈">
      <el-form :model="form">
        <el-form-item label="内容" :label-width="formLabelWidth">
          <el-input v-model="obj.content" autocomplete="off" maxlength="100" placeholder="100字内" />
        </el-form-item>
        <el-form-item label="上传" :label-width="formLabelWidth">
          <el-upload ref="upload" action="upload/feedback" :auto-upload="false" :limit="1"
            :data="{ 'content': obj.content, 'mobile_number': obj.mobileNumber }" :file-list="obj.fileList"
            :on-success="handleSuccess" :before-upload="beforeUpload" :headers="obj.headerObj">
            <template #trigger>
              <el-button type="primary">选择文件</el-button>
              <div>&nbsp;&nbsp;最多一个文件</div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="obj.dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="submitUpload">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from "vue";
import { useRouter, useRoute } from 'vue-router'
import { http, httpNoLoading } from '../util/http'
import { ElMessage } from 'element-plus'
import { LStorage } from '../util/storage';
export default {
  props: {
    visible: {
      type: String,
      default: false
    }
  },
  setup(props) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const route = useRoute()
    const upload = ref()
    const obj = reactive({
      dialogFormVisible: props.visible,
      content: '',
      fileList: [],
      flag: true,
      mobileNumber: LStorage.getItem('user'),
      headerObj: { auth: LStorage.getItem('auth') }
    })

    // 页面传来的事件处理
    vueEvent.on('feedbackDialogVisible', (flag) => {
      obj.dialogFormVisible = flag
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {

    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('feedbackDialogVisible', () => { })
    })

    // 按钮提交事件
    const submitUpload = (e) => {
      if (obj.content.trim() === '') {
        ElMessage({ showClose: true, message: '请输入问题内容' })
        return false
      }
      upload.value.submit()
      if (obj.flag) {
        postData()
      }
    }

    // 上传文件检测
    const beforeUpload = (e) => {
      // console.log(e)
      obj.flag = false
      if (e.size / 1024 / 1024 > 1) {
        console.log('false')
        ElMessage.error('文件大小不能大于1MB')
        return false
      }
    }

    // 上传文件成功后事件
    const handleSuccess = (e) => {
      console.log(e)
      // 上传文件没有错误的情况下，更新后台
      if (e.check_info != "") {
        ElMessage.error(e.check_info)
        return
      }
      let formData = new FormData()
      formData.append("content", obj.content)
      formData.append("file", e.data) // 文件服务器返回的文件保存路径
      http({
        url: `/feedback`,
        method: 'post',
        data: formData
      }).then((res) => {
        success()
      })
      // success()
    }

    // 提交事件（没有上传文件时的提交）
    const postData = () => {
      let formData = new FormData()
      formData.append("content", obj.content)
      http({
        url: `/feedback`,
        method: 'post',
        data: formData
      }).then((res) => {
        success()
      })
    }

    // 成功后清空数据并关闭对话框
    const success = () => {
      ElMessage({ showClose: true, message: '感谢您的反馈', duration: 2000 })
      obj.dialogFormVisible = false
      obj.content = ''
      obj.fileList = []
    }

    return {
      obj,
      upload,
      submitUpload,
      beforeUpload,
      handleSuccess,
    }
  }
}
</script>
<style lang="scss" scoped></style>
